import styled from 'styled-components';

export const FormGroup = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '3rem',
  width: '100%',
  marginLeft: 'auto',
  padding: '2rem 2rem',
  border: `1px dashed ${theme.palette.black}`,
}));

export const FormItemGroup = styled.div(({ theme }) => ({
  display: 'flex',
  gap: '3rem',
  width: '100%',
  marginLeft: 'auto',
  fontFamily: theme.typography.family.arial,
  fontSize: theme.typography.size14,
  lineHeight: 1.5,
  padding: '2rem 0',
  alignItems: 'start',
  justifyContent: 'start',
  '& label': {
    width: 'auto',
  },
  '& input': {
    width: '70%',
    padding: '0.5rem 1rem',
    borderRadius: '4rem',
    border: `1px solid ${theme.palette.black}`,
  },
  '& select': {
    width: '70%',
    padding: '0.5rem 1rem',
    borderRadius: '4rem',
    border: `1px solid ${theme.palette.black}`,
  },
}));

export const Button = styled.button(() => ({
  paddingInline: '20rem',
  fontSize: '14rem',
  margin: '10rem',
  padding: '2rem 5rem',
}));
